module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rotateDeviceOverlay"
  }, [(!_vm.hidden) ? _c('div', {
    staticClass: "iconContainer"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("turnDevice")))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone"
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77bc9386!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/RotateDevice.vue
// module id = 164
// module chunks = 0